module.exports = __webpack_public_path__ + "img/LKK.05e8d529.svg";